import {Injectable, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ConfigService} from './index';

@Injectable({providedIn: 'root'})
export class UrlService {
  constructor(
    private sanitizer: DomSanitizer,
    private configService: ConfigService,
  ) {}

  sanitizeUrl(url: string): string | null {
    return this.sanitizer.sanitize(SecurityContext.URL, url);
  }

  isURLDomainTrusted(url: string): boolean {
    try {
      const urlHostname: string = new URL(url).hostname;
      const trustedDomains: string[] = this.configService.getTrustedDomains();
      const urlRootDomain: string = this.getRootDomain(urlHostname);

      return trustedDomains.some((trustedDomain): boolean => {
        const trustedRootDomain: string = this.getRootDomain(trustedDomain);

        // Direct domain match or subdomain of a matching trusted domain
        return urlHostname.endsWith(`.${trustedRootDomain}`) || urlRootDomain === trustedRootDomain;
      });
    } catch (err) {
      console.error('Error processing URL for trusted domains:', err);
      return false;
    }
  }

  private getRootDomain(hostname: string): string {
    const hostnameParts: string[] = hostname.split('.');
    const genericTopLevelDomains: string[] = ['co', 'com', 'net', 'org'];

    if (hostnameParts.length < 2) {
      return hostname;
    } else if (genericTopLevelDomains.includes(hostnameParts[hostnameParts.length - 2])) {
      return hostnameParts.slice(-3).join('.');
    } else {
      return hostnameParts.slice(-2).join('.');
    }
  }
}
